import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import LoginForm from './components/login-form';
import RegisterForm from './components/register-form';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  withRouter,
  Redirect
} from 'react-router-dom'
import './statics/css/index.css';
import firebase from '@firebase/app';
import '@firebase/firestore';
import '@firebase/storage';
import '@firebase/auth';
import { FirestoreProvider } from 'react-firestore';
import { DB_CONFIG } from './config/config'
import PrivacyPolicy from './components/politica-privacidade';
import OnlineConsult from './components/online-consult';
firebase.initializeApp(DB_CONFIG)
firebase.firestore().settings({ timestampsInSnapshots: true })

//https://github.com/green-arrow/react-firestore

ReactDOM.render(
  <FirestoreProvider firebase={firebase}>
    <Router>
      <Switch>
        <Route path="/login" component={LoginForm} />
        <Route path="/registrar" component={RegisterForm} />
        <Route exact path="/privacy_policy" component={PrivacyPolicy} />
        <Route exact path="/consultoria_online" component={OnlineConsult} />
        <Route path="/" component={App} />
      </Switch>
    </Router>
  </FirestoreProvider>, document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// src/index.js